import { module } from 'modujs';
import barba from '@barba/core';
import {html} from '../utils/environment'
import defaultTransition from '../transitions/default'
import workListTransition from '../transitions/workList'
import workNextTransition from '../transitions/workNext'
import { lisaUserData } from './Lisa';

const toDash = str => str.split(/(?=[A-Z])/).join('-').toLowerCase()

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        barba.init({
            timeout: 10000,
            schema: {
                prefix: 'data-load'
            },
            transitions: [
                defaultTransition,
                workListTransition,
                workNextTransition
            ],
            prevent: ({el,event,href}) => {
                if(window.confirmPageChange && event.type == 'click') {
                    this.call('close', null, 'Nav');

                    if(window.confirmPageChange.context &&window.confirmPageChange.context == 'lisa') {
                        gtag?.('event', 'flow_exit_attempt', {
                            flow: lisaUserData?.goal,
                            step: window.confirmPageChange.step,
                            type: 'page_change',
                            audio: window.confirmPageChange.audio
                        });
                    }

                    barba.prefetch(href)

                    if(window.confirm(window.confirmPageChange.message)) {
                        if(window.confirmPageChange.context && window.confirmPageChange.context == 'lisa') {
                            gtag?.('event', 'flow_exit', {
                                flow: lisaUserData?.goal,
                                step: window.confirmPageChange.step,
                                type: 'page_change',
                                audio: window.confirmPageChange.audio
                            });
                        }

                        const barbaLoad = barba.go(href);
                        if(!barbaLoad) window.location = href;
                    }

                    event.preventDefault()
                    return true;
                } else {
                    const forceReload = el.getAttribute('data-load') == 'false' || false;

                    if(window.location.href == href) {
                        event.preventDefault()
                        event.stopPropagation();

                        return true
                    } else if(forceReload) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        });

        barba.hooks.before(this.before.bind(this))
        barba.hooks.beforeLeave(this.beforeLeave.bind(this))
        barba.hooks.leave(this.leave.bind(this))
        barba.hooks.afterLeave(this.afterLeave.bind(this))
        barba.hooks.enter(this.enter.bind(this))
        barba.hooks.after(this.after.bind(this))
    }

    before(data, transition) {}

    beforeLeave() {}

    leave() {
        this.call('reset', null, 'Hovers')
        this.call('hideMenu', null, 'Header')
        //add is-loading state
        html.classList.add('is-loading');
        html.classList.remove('is-loaded');
        html.classList.remove('is-ready');
    }

    afterLeave(data) {
        // console.log('afterLeave', data);
        this.call('destroy', data.current.container, 'app');
        data.current.container.remove()
    }

    beforeEnter() {}

    enter(data) {
        // console.log('enter', data);
        // Retrieve HTML dataset on next container and update our real html element dataset accordingly
        const parser = new DOMParser();
        let nextDOM = parser.parseFromString(data.next.html, 'text/html');
        let newDataset = Object.assign({}, nextDOM.querySelector('html').dataset);
        Object.entries(newDataset).forEach(([key, val]) => {
            html.setAttribute('data-' + toDash(key), val);
        });

        // Wait for a first render to properly start next page
        requestAnimationFrame(() => {
            html.classList.remove('is-loading');
            html.classList.add('is-loaded');
            this.call('update', data.next.container, 'app');
        })
    }

    manualGo(el) {
        barba.go(el.href, el);
    }

    after(data) {
        // console.log('after', data);

        html.classList.add('is-ready');
        this.call('update', null, 'Hovers')
    }
}
